export interface AuthMeCohort {
  id: number;
  name: string;
}

export interface AuthMeOrg {
  id: number;
  name: string;
  slug?: string;
  parent_org?: number | null;
}

export interface AuthMeUser {
  id: number;
  username?: string;
  email: string;
  first_name: string;
  last_name: string;
}

export interface AuthMeResponse {
  user: AuthMeUser;
  tenants?: Array<{ id: number; name: string; slug: string; is_active?: boolean }>;
  current_tenant?: { id: number; name: string; slug: string; is_active?: boolean };
  current_org?: AuthMeOrg;
  current_cohorts?: AuthMeCohort[];
}

/** Scope id for APIs that expect the former current_org.id — now current_cohorts[0].id. */
export function resolveAuthMeScopeId(
  data: Pick<AuthMeResponse, 'current_cohorts' | 'current_org'>
): string | null {
  const primaryCohortId = data.current_cohorts?.[0]?.id;
  if (primaryCohortId != null) {
    return String(primaryCohortId);
  }

  // Legacy fallback until prod ships current_cohorts everywhere
  const orgId = data.current_org?.id;
  return orgId != null ? String(orgId) : null;
}

export function getAuthMeCohorts(
  data: Pick<AuthMeResponse, 'current_cohorts'>
): AuthMeCohort[] {
  return data.current_cohorts ?? [];
}
